// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A7sG","questions":"styles_questions__1_JZ8","footer":"styles_footer__1X-76"};